export default {
  props: {
    size: {
      type: String,
      default: 'md'
    },
    // | lg | md | sm | xs |
    variant: {
      type: String,
      default: 'primary'
    },
    // | primary | secondary | outlined | outlined_light | tinted | plain | default
    reversed: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    stretch: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    rotateicon: {
      type: String,
      default: '0'
    },
    callback: {},
    selected: {
      type: Boolean
    }
  }
};